import cn from 'classnames';
import React, { ReactNode } from 'react';
import { DivProps } from 'src/shared/types/props';
import { Heading } from 'src/shared/ui/Heading';
import { Paragraph } from 'src/shared/ui/Paragraph';
import s from './ServiceCard.module.scss';
import { ButtonPrimary } from 'src/shared/ui/_buttons/ButtonPrimary';

interface Props extends DivProps {
	Title: ReactNode | string;
	Description: ReactNode | string;
	SVG: ReactNode;
	cta: {
		text: string;
		onClick?: () => void;
	};
}

export const ServiceCard: React.FC<Props> = (props) => {
	const {
		Title, //
		Description,
		SVG,
		cta,
		className,
		...divProps
	} = props;

	// * Render
	return (
		<div
			{...divProps}
			className={cn(s.container, className)}
		>
			<div>
				<Heading
					level={3}
					marginBottom="m"
				>
					{Title}
				</Heading>

				<Paragraph marginBottom="m">{Description}</Paragraph>
			</div>

			<div className={s.footer}>
				{cta.onClick ? <ButtonPrimary onClick={cta.onClick}>{cta.text}</ButtonPrimary> : <b style={{ height: '1.5rem', color: 'var(--color-primary-main)' }}>{cta.text}</b>}

				<div className={s.img}>{SVG}</div>
			</div>
		</div>
	);
};
